module.exports = __webpack_public_path__ + "436f6085c21dd7a1c2156a4ce294923a.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background/storm.mp3
// module id = 3875
// module chunks = 0